import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class AndroidService {

  constructor(private httpClient: HttpClient) { }

  get(): Observable<Downloads> {
    return this.httpClient.get<Downloads>(Constants.apps);
  }

  post(input: number): Observable<Downloads> {
    return this.httpClient.post<Downloads>(Constants.apps + "?i=" + input, null);
  }
}

export class Downloads {
  id = 0;
  totalVisitors = 0;
  todaysVisitors = 0;
  anvayAppDownloads = 0;
  sarvadhnyaAppDownload = 0;
  sthanAppDownload = 0
}